import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import user from './user'
import demo from './demo'
import job from './job'
import site from './site'
import board from './board'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    user,
    demo,
    job,
    site,
    board,
    {
      path: '/',
      redirect: { name: 'auth.login-page' }
    },
    {
      path: '/qr',
      name: 'qr-page',
      component: () => import(/* webpackChunkName: "qr-page" */ '@/views/qr/')
    },
    {
      path: '/frequently-asked-questions',
      name: 'frequently-asked-questions',
      component: () =>
        import(/* webpackChunkName: "frequently-asked-questions" */ '@/views/general/FAQ')
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () =>
        import(/* webpackChunkName: "terms-of-service" */ '@/views/general/TermsOfService')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ '@/views/general/PrivacyPolicy')
    },
    {
      path: '/service-unavailable',
      name: 'service-unavailable',
      component: () =>
        import(/* webpackChunkName: "service-unavailable" */ '@/views/error/ServiceUnavailable')
    },
    {
      path: '*',
      name: 'page-not-found',
      component: () =>
        import(/* webpackChunkName: "page-not-found" */ '@/views/error/PageNotFound')
    }
  ],

  //  this feature only works if the browser supports history.pushState
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
